import { render, staticRenderFns } from "./duerrenmatt.vue?vue&type=template&id=efa49f48&scoped=true&"
import script from "./duerrenmatt.vue?vue&type=script&lang=js&"
export * from "./duerrenmatt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa49f48",
  null
  
)

export default component.exports